// notify.js is a UMD module (Notify.js - http://notifyjs.com/).
//
// Dev mode:  Vite serves the file as-is. The UMD IIFE hits the browser
//            globals branch and calls factory(jQuery), attaching $.notify.
// Prod mode: Rolldown detects the CommonJS branch (typeof module === 'object')
//            natively and wraps the module. factory(jQuery) is NOT called, so
//            $.notify is missing. We detect this and call the exported
//            factory manually.
//
// NOTE: build.commonjsOptions はVite8(Rolldown)ではno-opのため設定不要。
//       Rolldownが標準でCJS分岐を自動検出する。
import * as notifyModule from './src/notify';

if (window.jQuery && typeof window.jQuery.notify !== 'function') {
  const factory = notifyModule.default;
  if (typeof factory === 'function') {
    factory(window, window.jQuery);
  }
}
